export default __webpack_public_path__ + "static/media/Destination3.b4028caa.png";